import {Component} from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent {
  ano: number;
  supportText: string;
  phoneNumber: string;
  frequentlyAskQuestions: string;

  constructor() {
    this.ano = new Date().getFullYear();
    this.supportText = 'Support desk';
    this.phoneNumber = '800 521 100';
    this.frequentlyAskQuestions = 'Frequently asked questions';
  }
}
